import { Link as RouterLink } from 'react-router-dom';
import { useLocalization } from '@fluent/react';

import BookingSummaryPanel from '#/components/panels/BookingSummaryPanel';
import UserProfilePanel from '#/components/panels/UserProfilePanel';
import brandLogoUrl from '#/assets/brand_logo.svg';
import { AdminRoute } from '#/constants/page-route';
import { Role } from '#/__generated__/graphql/graphql';
import { useManagingProfile, useUser } from '#/hooks';

const SideMenu = () => {
  const { l10n } = useLocalization();
  const user = useUser();
  // const role = user.roles[0].slug;
  const hasAdminRoles = (roles: Role[]) =>
    roles.some((role) => ['superadmin', 'admin'].includes(role.slug));
  const managingProfile = useManagingProfile();

  // TODO: Get from API later
  const userType = managingProfile?.__typename;
  const companyName = managingProfile?.name;

  return (
    <aside className="h-screen bg-white sticky top-0">
      <div className="flex flex-col justify-between h-full">
        <div className="flex-1 p-6 2xl:p-8 ">
          <header className="mb-2 2xl:mb-6">
            <img src={brandLogoUrl} className="w-48" />
          </header>

          <div className="divide-y divide-gray-300">
            {/* <div className="text-black py-4 2xl:py-6">{l10n.getString('dashboard')}</div> */}

            {!hasAdminRoles(user.roles) && (
              <div className="py-6">
                <BookingSummaryPanel />
              </div>
            )}

            {/*
            <div className="py-4 space-y-3 flex flex-col">
              <Link onClick={() => console.log('test')} className="text-white">
                {l10n.getString('address-book')}
              </Link>
              <Link className="text-white">{l10n.getString('payment-and-billing')}</Link>
            </div>

          */}
            {hasAdminRoles(user.roles) && (
              <div className="py-6">
                <div className="text-gray-400 text-sm mb-6 uppercase">
                  {l10n.getString('settings')}
                </div>
                <div className="py-4 space-y-3 flex flex-col">
                  <RouterLink to={AdminRoute.UserList}>{l10n.getString('users')}</RouterLink>
                  <RouterLink to={AdminRoute.CustomerList}>{l10n.getString('clients')}</RouterLink>
                  <RouterLink to={AdminRoute.LogisticsList}>
                    {l10n.getString('logistics')}
                  </RouterLink>
                  <RouterLink to={AdminRoute.OrderList}>{l10n.getString('orders')}</RouterLink>
                </div>
              </div>
            )}
          </div>
        </div>

        <footer>
          <div className="bg-neutral-100">
            <div className="py-4 2xl:py-6 px-6">
              <UserProfilePanel />
            </div>
          </div>
          {!!companyName && (
            <div className="space-y-6 2xl:space-y-8 pt-4 2xl:pt-6 px-6 pb-6">
              <div className="text-neutral-400">{companyName}</div>
            </div>
          )}
        </footer>
      </div>
    </aside>
  );
};

export default SideMenu;
